module.exports = __webpack_public_path__ + "static/media/alibaba_register_background.1534c258.png";